import { useTracking } from '@change-corgi/core/react/tracking';

import { useTopicPageData, useTopicPagePaginatedPetitionUpdatesData } from 'src/app/pages/topic/pageContext';

type PetitionUpdates = ReturnType<typeof useTopicPagePaginatedPetitionUpdatesData>['data']['items'];

type Result = ModelHookResult<
	{
		displayed: boolean;
		name: string;
		petitionUpdates: PetitionUpdates;
		hasNextPage: boolean;
		nextPageLoading: boolean;
	},
	{
		loadMore: () => void;
	}
>;

export function usePetitionUpdates(): Result {
	const {
		data: { name },
	} = useTopicPageData();

	const {
		data: { hasNextPage, items, nextPageLoading, totalCount },
		actions: { loadMore },
	} = useTopicPagePaginatedPetitionUpdatesData();
	const track = useTracking();

	return {
		data: {
			displayed: totalCount > 0,
			name,
			petitionUpdates: items,
			hasNextPage,
			nextPageLoading,
		},
		actions: {
			loadMore: () => {
				void track('topic_updates_show_more');
				loadMore();
			},
		},
	};
}
